import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'showBreakLines',
})
export class ShowBreakLinesPipe implements PipeTransform {

    transform(str: string) {
        return '<p>' + str.replace(/(?:\r\n|\r|\n)/g, '<br>') + '</p>';
    }
}



// WEBPACK FOOTER //
// ./src/pipes/show-break-lines.ts